import { extendTheme } from "@chakra-ui/react";

const modalTheme = extendTheme({
  components: {
    Modal: {
      baseStyle: {
        dialog: {
          borderRadius: "8px",
          maxWidth: "724px",
          maxHeight: "550px",
        },
        body: {
          padding: "32px",
        },
      },
    },
    Text: {
      variants: {
        missionTitle: {
          fontSize: "32px",
          fontWeight: "600",
          lineHeight: "40px",
        },
        missionDescription: {
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "30px",
          color: "#666A6B",
          textAlign: "center",
        },
      },
    },
  },
});

export default modalTheme;
